var _path, _path2, _circle, _circle2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31B59F",
    d: "M1.296 12.174h36.246v6.673H1.296z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.116 23.697V10.343a3.568 3.568 0 0 0-3.564-3.564H4.259a3.567 3.567 0 0 0-3.564 3.564v19.602a3.567 3.567 0 0 0 3.564 3.563h22.004M26.214 35.679H3.393c-.112 0-.22-.01-.33-.017l.865 4.87c.171.962.706 1.799 1.506 2.357a3.624 3.624 0 0 0 2.731.602l20.104-3.466",
    stroke: "#35404A",
    strokeWidth: 1.359
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.687,
    cy: 23.853,
    r: 2.028,
    transform: "rotate(-90 6.687 23.853)",
    stroke: "#35404A",
    strokeWidth: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.944,
    cy: 23.853,
    r: 2.028,
    transform: "rotate(-90 8.944 23.853)",
    stroke: "#35404A",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.431 25.11a10.125 10.125 0 0 0-5.643-1.496c-5.615.18-10.022 4.876-9.843 10.491.179 5.615 4.876 10.022 10.491 9.843 5.615-.179 10.022-4.876 9.843-10.491a10.126 10.126 0 0 0-2.039-5.792",
    stroke: "#35404A",
    strokeWidth: 1.359,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.69 39.407a5.33 5.33 0 0 1-1.857-.325 3.093 3.093 0 0 1-1.03-.637c-.264-.246-.215-.66.058-.898.317-.276.806-.197 1.14.058.123.095.258.18.405.255.413.206.84.32 1.284.34V34.27a7.343 7.343 0 0 1-1.16-.403 4.4 4.4 0 0 1-.991-.634 2.806 2.806 0 0 1-.666-.883c-.165-.35-.247-.758-.247-1.222 0-.434.082-.831.247-1.192.166-.361.387-.671.666-.93.289-.267.62-.479.99-.634a3.5 3.5 0 0 1 1.161-.294v-.65a.371.371 0 0 1 .743 0v.65c.558 0 1.105.103 1.641.31.319.12.606.277.861.47.307.233.275.68-.01.938-.274.25-.7.202-1-.02a2.38 2.38 0 0 0-.377-.227 2.398 2.398 0 0 0-1.115-.263v3.854c.413.134.816.278 1.208.433.392.155.738.35 1.037.588.31.227.552.511.727.852.186.34.279.763.279 1.269a2.9 2.9 0 0 1-.263 1.254 2.986 2.986 0 0 1-.712.96c-.29.268-.63.48-1.022.634-.392.155-.81.248-1.254.279v.727a.372.372 0 0 1-.743 0v-.727zm0-10.122c-.505.092-.913.304-1.222.634-.3.32-.45.728-.45 1.223 0 .268.042.495.125.681.093.186.211.346.356.48.154.134.33.253.526.356.206.093.428.186.665.279v-3.653zm.743 8.915c.527-.062.965-.263 1.316-.604.361-.34.542-.758.542-1.253 0-.279-.052-.521-.155-.728a1.602 1.602 0 0 0-.418-.526 2.326 2.326 0 0 0-.604-.356 4.91 4.91 0 0 0-.68-.263v3.73z",
    fill: "#31B59F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44.526 43.954 1.508 1.872M46.985 40.35l2.383.32M40.48 45.593l-.194 2.396",
    stroke: "#31B59F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCards);
export default __webpack_public_path__ + "static/media/credit-cards.fa5552e68d556bfb840c67b36d3b6ed7.svg";
export { ForwardRef as ReactComponent };